import { ref } from 'vue'

// True while the current quote is blocked (referred / declined). The quote display shows its own
// full message card in that state, so journey chrome (e.g. the teleported page title) hides itself.
export const quoteBlocked = ref(false)
